import React from "react";
import { useSelector } from "react-redux";
import { DocumentIcon } from "staysure-component-library";

import LabelButtonWrapper, {
  IconButtonWrapper,
} from "@/components/atoms/button-wrapper/button-wrapper";
import { openInNewTab } from "@/components/molecules/policy-document-section/policy-content/docs.utils";
import { RootState } from "@/store/root-reducer";

type DocumentSectionProps = {
  cmsData: {
    documentsInfoText: string;
    documentsSectionTitle: string;
    documentTitle: string;
  };
};

function DocumentSection({ cmsData }: DocumentSectionProps) {
  const { documentsInfoText, documentsSectionTitle, documentTitle } = cmsData;
  const { attributes } = useSelector((state: RootState) => state.quote);
  return (
    <div>
      <p className="font-body-font text-xs font-[700] leading-[27px] text-text-functional-subtle mb-spacing-xs">
        {documentsSectionTitle}
      </p>
      <p className="font-body-font text-2xs font-[400] leading-[24px] text-text-functional-1 mb-spacing-xs">
        {documentsInfoText}
      </p>
      <div className={`flex items-center h-fit gap-spacing-xs `}>
        <div>
          <IconButtonWrapper
            hierarchy="tertiary"
            btnType="icon"
            isDisabled
            icon={<DocumentIcon stroke="rgba(39, 36, 39, 1)" />}
            className="!max-w-[24px] h-[24px] text-[24px] text-text-on-primary !px-0 !max-h-[27px] !my-0 !py-0 !bg-surface-neutral-option-1 active:!bg-surface-neutral-option-1 hover:!bg-surface-neutral-option-1"
          />
        </div>
        <div>
          <LabelButtonWrapper
            label={documentTitle}
            hierarchy="tertiary"
            className="font-body-font leading-[27px] font-[600] realtive text-xs top-[-4px] !px-[0px]"
            onClick={() =>
              openInNewTab(
                attributes.dynamicDocuments?.documentUrls.renewalNotice
              )
            }
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentSection;
